import WhyChooseGrowboo from "../../components/WhyChooseGrowboo/WhyChooseGrowboo";
import NewHeader from "../../LandingPage/HeaderComponent/Header";
import GrowbooWorks from "../../components/GrowbooWorks/GrowbooWorks";

import TestimonialsSection from "../../components/TestimonialsSection/TestimonialsSection";
import Footer from "../../components/Footer/Footer";

const HowToStart = () => {
  return (
    <>
      <NewHeader />
      <GrowbooWorks />
      <WhyChooseGrowboo />
      {/* <TestimonialsSection /> */}
      <Footer />
    </>
  );
};

export default HowToStart;
